import {TeacherModelV1} from 'resources/GeneratedModels/Teacher/TeacherModel.v1';
import {userModelExtensions} from 'resources/augmented/User/user.extensions';
import teacherModelExtensions from './teacher.extensions';

TeacherModelV1.extend(userModelExtensions, teacherModelExtensions);

export {TeacherModelV1};
